import React, { Fragment } from 'react'
import { Box, Typography, Divider } from '@mui/material'
import { ConfigItem, ConfigLine } from './ConfigLine'

interface ConfigListProps {
  items: ConfigItem[]
  /** Guarda un item. Devuelve true si fue exitoso. */
  onSave: (item: ConfigItem, newValue: string) => Promise<boolean>
}

const BoolHeader = () => (
  <Box
    display='grid'
    gridTemplateColumns='1fr minmax(250px, 30%) minmax(250px, 30%)'
    alignItems='center'
    px={3}
    py={1}
    sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'grey.50' }}
  >
    <Typography variant='caption' fontWeight={500} color='text.secondary'>
      Configuración
    </Typography>
    <Typography variant='caption' fontWeight={500} color='text.secondary' textAlign='center'>
      Activo
    </Typography>
    <Typography variant='caption' fontWeight={500} color='text.secondary' textAlign='center'>
      Inactivo
    </Typography>
  </Box>
)

const ValueHeader = ({ hideConfigLabel = false }: { hideConfigLabel?: boolean }) => (
  <Box
    display='grid'
    gridTemplateColumns='1fr minmax(500px, 60%)'
    alignItems='center'
    px={3}
    py={1}
    sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'grey.50' }}
  >
    <Typography variant='caption' fontWeight={500} color='text.secondary'>
      {hideConfigLabel ? '' : 'Configuración'}
    </Typography>
    <Typography variant='caption' fontWeight={500} color='text.secondary' textAlign='center'>
      Valor
    </Typography>
  </Box>
)

export const ConfigList = ({ items, onSave }: ConfigListProps) => {
  const boolItems = items.filter((i) => i.dataType === 'bool')
  const valueItems = items.filter((i) => i.dataType !== 'bool')

  const hasBoth = boolItems.length > 0 && valueItems.length > 0

  const renderGroup = (group: ConfigItem[], header: React.ReactNode) => {
    if (group.length === 0) return null
    return (
      <Box>
        {header}
        {group.map((item, index) => (
          <Fragment key={item.key}>
            <ConfigLine {...item} onSave={(newValue) => onSave(item, newValue)} />
            {index < group.length - 1 && <Divider />}
          </Fragment>
        ))}
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      {renderGroup(boolItems, <BoolHeader />)}

      {hasBoth && <Divider sx={{ borderWidth: 2 }} />}

      {renderGroup(valueItems, <ValueHeader hideConfigLabel={hasBoth} />)}
    </Box>
  )
}
